import React from 'react'
import styled from 'styled-components';
import { experiences } from '../../data/constants';
import ExperienceCard from '../Card/experienceCard';
import { useLanguage } from '../../utils/LanguageContext';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 0px 80px 0px;
    @media (max-width: 960px) {
        padding: 20px 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 80px 0;
    gap: 12px;
    @media (max-width: 960px) {
        padding: 40px 0;
    }
`;

const Title = styled.div`
    font-size: 42px;
    text-align: center;
    font-weight: 600;
    margin-top: 20px;
    color: ${({ theme }) => theme.text_primary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 32px;
    }
`;

const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    padding: 0 16px;
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

const ScrollContainer = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;

    @media (max-width: 768px) {
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        padding: 0 20px 12px 25px;
        scrollbar-width: thin;
        scrollbar-color: ${({ theme }) => theme.primary + '60'} transparent;
        
        &::-webkit-scrollbar {
            height: 4px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: ${({ theme }) => theme.primary + '60'};
            border-radius: 4px;
        }
    }
`;

const CardRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    @media (max-width: 768px) {
        flex-direction: row;
        align-items: stretch;
        width: max-content;
        gap: 16px;
    }
`;

const CardWrapper = styled.div`
    @media (max-width: 768px) {
        scroll-snap-align: start;
        flex-shrink: 0;
        width: 85vw;
        max-width: 340px;
        display: flex;
    }
`;

const Experience = () => {
  const { t } = useLanguage();

  return (
    <Container id="experience">
      <Wrapper>
        <Title>{t.experienceTitle}</Title>
        <Desc>{t.experienceDesc}</Desc>
        <ScrollContainer>
          <CardRow>
            {experiences.map((item) => (
              <CardWrapper key={item.id}>
                <ExperienceCard experience={item} />
              </CardWrapper>
            ))}
          </CardRow>
        </ScrollContainer>
      </Wrapper>
    </Container>
  )
}

export default Experience
